<template>
    <v-container fluid class="" style="margin-top: 20px">
        <v-card>
            <v-card color="primary">
                <v-card-title class="title-text"> Publicar Artículo </v-card-title>
            </v-card>
            <v-card-text>
                <div style="height: 10px;"></div>
                <v-row justify="center">
                    <v-col cols="12" md="10">
                        <v-form ref="formBlog">
                            <v-container>
                                <v-row justify="center" class="mb-10">
                                    <v-col cols="12" md="6">
                                        <v-text-field label="Título" outlined v-model="blogTitle" :rules="rules"
                                            v-on:blur="blogTitle = blogTitle != null ? blogTitle.trim() : null">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-text-field label="Autor" outlined v-model="blogAutor" :rules="rules"
                                            v-on:blur="blogAutor = blogAutor != null ? blogAutor.trim() : null">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea label="Descripción" outlined v-model="blogDescrip"
                                            v-on:blur="blogDescrip = blogDescrip != null ? blogDescrip.trim() : null"
                                            :rules="rules"></v-textarea>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-file-input color="deep-purple accent-4" label="Imagen" outlined
                                            v-model="blogImage" required accept=".jpg, .png, .jpeg, .gif"
                                            :rules="requiredRules">
                                            <template v-slot:selection="{ index, text }">
                                                <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>
                                                    {{ text }}
                                                </v-chip>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-combobox v-model="blogKeyWords" :items="KeWordsItems" chips outlined
                                            label="Palabras Clave" multiple class="fixed-combobox">
                                        </v-combobox>
                                    </v-col>
                                    <v-col cols="12">
                                        <h4>Seleccione una o más categorías:</h4>
                                        <v-chip-group column color="primary" multiple v-model="blogCategories">
                                            <v-chip v-for="tag in categoryItems" :key="tag.clave" :value="tag.clave">
                                                {{ tag.categoria }}
                                            </v-chip>
                                        </v-chip-group>
                                    </v-col>
                                    <v-col cols="12" class="mt-5">
                                        <vue-editor v-model="editorContent"></vue-editor>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-5 px-4" @click="savePublish()"> Guardar Borrador </v-btn>
                <v-btn class="px-4" color="primary" @click="publishPost()"> Publicar </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            <div style="height: 100px;"></div>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import BlogService from "@/services/Blogs/Blogs.service.js";;
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { VueEditor } from "vue2-editor";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        VueEditor,
    },
    data() {
        return {
            categoryItems: [],
            deletedCategoriesList: [],
            deleatingStatus: false,
            deleatedTags: [],

            blogTitle: "",
            blogAutor: "",
            blogDescrip: "",
            blogImage: null,
            blogKeyWords: "",
            blogCategories: [],

            editorContent: " ",

            KeWordsItems: [
                'Nuevo',
                'Clientes',
                'Abogados',
                'Informacion',
            ],

            rules: [
                v => !!v || 'Campo requerido',
                v => (v && v.length > 3) || 'Agregue más de 3 caracteres',
            ],

            requiredRules: [
                v => !!v || 'Campo requerido',
            ]
        };
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    async mounted() {
        this.obtenerCategorias();
    },
    methods: {
        async obtenerCategorias() {
            let response = await BlogService.ObtenerCategoriasTodas();
            this.categoryItems = response;
        },

        async savePublish() {

            setTimeout(async () => {

                this.$refs.formBlog.validate();

                if (this.blogImage == null) {
                    this.$swal.close();
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Datos incompletos",
                        text: "Por favor rellene todos los campos e intente nuevamente",
                        showConfirmButton: true,
                        timer: 5000,
                    });
                    return;
                }

                if (this.blogCategories.length == 0) {
                    this.$swal.close();
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Falta Categoría",
                        text: "Por favor, seleccione al menos una categoría para su publicación",
                        showConfirmButton: true,
                        timer: 5000,
                    });
                    return;
                }

                if (this.$refs.formBlog.validate() == true) {

                    this.$swal({
                        title: "Guardando la publicación, espere un momento...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                    let formData = new FormData();
                    formData.append("batitulo", this.blogTitle);
                    formData.append("badesc", this.blogDescrip);
                    formData.append("bacontenido", this.editorContent);
                    formData.append("baautor", this.blogAutor);
                    formData.append("categorias", JSON.stringify(this.blogCategories));
                    formData.append("palabras", JSON.stringify(this.blogKeyWords));
                    formData.append("file", this.blogImage);
                    let response = await BlogService.PublicarBorrador(formData);

                    if (response == true) {
                        this.$refs.formBlog.reset();
                        this.editorContent = " ";
                        this.blogKeyWords = [];

                        this.$swal.close();
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Correcto",
                            text: "Los datos se guardaron correctamente",
                            showConfirmButton: true,
                            timer: 5000,
                        }).then(() => {
                            this.$emit('cancel-edit');
                        });

                    } else {
                        this.$swal.close();
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Oops...",
                            text: "Ha ocurrido un error inesperado intente nuevamente más tarde",
                            showConfirmButton: true,
                            timer: 5000,
                        });
                    }
                }
            }, 2000);
        },

        async publishPost() {
            try {
                this.$swal({
                    title: "Guardando la publicación, espere un momento...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                setTimeout(async () => {
                    this.$refs.formBlog.validate();

                    if (this.blogImage == null) {
                        this.$swal.close();
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Datos incompletos",
                            text: "Por favor rellene todos los campos e intente nuevamente",
                            showConfirmButton: true,
                            timer: 5000,
                        });
                        return;
                    }

                    if (this.blogCategories.length == 0) {
                        this.$swal.close();
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Falta Categoría",
                            text: "Por favor, seleccione al menos una categoría para su publicación",
                            showConfirmButton: true,
                            timer: 5000,
                        });
                        return;
                    }

                    if (this.$refs.formBlog.validate() == true) {
                        let formData = new FormData();

                        formData.append("batitulo", this.blogTitle);
                        formData.append("badesc", this.blogDescrip);
                        formData.append("bacontenido", this.editorContent);
                        formData.append("baautor", this.blogAutor);
                        formData.append("categorias", JSON.stringify(this.blogCategories));
                        formData.append("palabras", JSON.stringify(this.blogKeyWords));
                        formData.append("file", this.blogImage);
                        formData.append("perfil", "A");
                        let response = await BlogService.PublicarArticuloNuevo(formData);

                        if (response == true) {
                            this.$refs.formBlog.reset();
                            this.editorContent = " ";
                            this.blogKeyWords = [];

                            this.$swal.close();
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Correcto",
                                text: "Los datos se guardaron correctamente",
                                showConfirmButton: true,
                                timer: 5000,
                            }).then(() => {
                                this.$emit('cancel-edit');
                            });
                        } else {

                            this.$swal.close();
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Oops...",
                                text: "Ha ocurrido un error inesperado intente nuevamente más tarde",
                                showConfirmButton: true,
                                timer: 5000,
                            });
                        }
                    }
                }, 2000);

            } catch (e) {
                console.log("Exp:", e)
                this.$swal.close();
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Oops...",
                    text: "Ha ocurrido un error inesperado intente nuevamente más tarde",
                    showConfirmButton: true,
                    timer: 5000,
                });
            }
        }
    },
};
</script>

<style>
.fixed-combobox .v-select__selections {
    min-height: 48px !important;
    height: 48px !important;
}
</style>

<style scoped>
.title-text {
    font-family: "Poppins", sans-serif;
    font-size: 1.3rem !important;
    font-weight: 600 !important;
    color: white;
}
</style>
